/* eslint-disable prefer-arrow-callback */
import _ from 'lodash';

import definitions from '../../../API_MOCKS/definition/index.json';
import Ellipsed from '../../views/Ellipsed';
import { recordToID } from '../../store/models/SpottingGroup';
import { MODEL_SPOTTING_GROUP_IDENTITY } from '../../store/models/SpottingGroup/spottingGroupConstants';

import { Icon } from  'antd';
import SpottingGroup from '../../store/models/SpottingGroupRecord';
import compString from '../../utils/compString';
import Button from '../../views/StyledButton';
import React from 'react';

export default (bottle) => {
  bottle.constant('SPOTTING_GROUP_ROOT_URL', '/spotting-groups');

  bottle.constant('spottingGroupSpecData', definitions);

  bottle.factory('keywordsFromTerms', () => SpottingGroup.keywordsFromTerms);

  // eslint-disable-next-line arrow-body-style
  bottle.factory('editUrl', function ({ SPOTTING_GROUP_ROOT_URL }) {
    return data => `${SPOTTING_GROUP_ROOT_URL}/drilldown/${btoa(recordToID(data))}`;
  });
  bottle.factory('newUrl', ({ SPOTTING_GROUP_ROOT_URL }) => `${SPOTTING_GROUP_ROOT_URL}/new`);

  bottle.factory('spottingGroupColumns', () => ({ goSpottingGroup, downloadGroupCSV, size }) => [
    {
      title: 'Group Name',
      dataIndex: MODEL_SPOTTING_GROUP_IDENTITY,
      width: size === 'small' ? 300 : null,
      sorter: (vocA, vocB) => compString(_.get(vocA, 'groupName', ''), _.get(vocB, 'groupName', '')),
    },
    (size === 'large') && {
      title: 'Words',
      dataIndex: 'keywords',
      key: 'termCount',
      align: 'right',
      width: 100,
      sorter: (a, b) => {
        const termCountA = _.get(a, 'keywords.length', 0);
        const termCountB = _.get(b, 'keywords.length', 0);
        return _.clamp(termCountA - termCountB, -1, 1);
      },
      render: (text, record) => (!(record.keywords && Array.isArray(record.keywords)) ? 0 : record.keywords.length),
    },
    (size === 'large') && {
      title: 'Keywords (sample)',
      dataIndex: 'keywords',
      width: 150,
      render: keywords => (
        <Ellipsed width={200}>
          {keywords.length ? (`"${_(keywords).sortBy(_.identity).slice(0, 4).join('", "')}"`) : '(no keywords)'}
        </Ellipsed>
      ),
    },

    {
      key: 'controlButtons',
      dataKey: MODEL_SPOTTING_GROUP_IDENTITY,
      width: size === 'large' ? 130 : 80,
      align: 'right',
      render: id => ( <div style={{ whiteSpace: 'nowrap', height: '30px' }}>
        <Button
          onClick={() => downloadGroupCSV(id)}
          size="small"
        >
          {size === 'large' ? 'Download CSV' : 'CSV'}
        </Button>
        <Button
          onClick={() => goSpottingGroup(id)}
          size="small"
        >
            <Icon type="edit" />
        </Button>
        </div>
      ),
    },
  ].filter(a => a));
};
